import moment from 'moment';

export function addMomentWeekdays(
  date: moment.Moment,
  days: number
): moment.Moment {
  date = moment(date); // use a clone
  while (days > 0) {
    date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      days -= 1;
    }
  }
  return date;
}

export function addWeekdays(date: Date, days: number): Date {
  const momentDate = moment(date);
  const addWeekdayDate = addMomentWeekdays(momentDate, days);
  return new Date(addWeekdayDate.toLocaleString());
}

export function countWeekdays(startDate: Date, endDate: Date): number {
  let date = moment(startDate).startOf('days');
  let count = 0;
  while (date < moment(endDate).startOf('days')) {
    date = date.add(1, 'days');
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      count += 1;
    }
  }
  return count;
}
